export const DEBOUNCE_DELAY = 3000;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:8080";
export const GOOGLE_MAPS_API_KEY =
  import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "AIzaSyCU1akv976YaNRuhkC2D3J1Q2Pb5fE2E8M";
